import { useIsAdmin, useIsSuperAdmin } from 'providers/UserProvider';
import { useIsCustomer } from 'providers/CustomerProvider';
import { Redirect, Route } from 'react-router-dom';
import { getNavigationInStorage, getUserInStorage } from './Storage';

const flattenNavigationPaths = (items = []) =>
  items.reduce((paths, item) => {
    if (item?.to) paths.push(item.to);
    if (Array.isArray(item?.items)) {
      paths.push(...flattenNavigationPaths(item.items));
    }
    return paths;
  }, []);

const canAccessPath = (pathname) => {
  const navigationPaths = flattenNavigationPaths(getNavigationInStorage() || []);
  return navigationPaths.some((navigationPath) => {
    if (navigationPath === '/') return pathname === '/';
    return (
      pathname === navigationPath ||
      pathname.startsWith(`${navigationPath}/`)
    );
  });
};

export default function AdminRoute({ component: Component, ...rest }) {
  const isAdmin = useIsAdmin();
  const isSuperAdmin = useIsSuperAdmin();
  const isCustomer = useIsCustomer();
  console.log("isAdmin",isAdmin)
  console.log("isSuperAdmin",isSuperAdmin)
  return (
    <Route
      {...rest}
      render={(props) =>
        isSuperAdmin ||
        getUserInStorage()?.isSuperAdmin ||
        ((isAdmin || getUserInStorage()?.isAdmin) &&
          canAccessPath(props.location.pathname)) ? (
          <Component {...props} />
        ) : isCustomer ? (
          <Redirect to="/customer/events" />
        ) : (
          <Redirect to="/invoices" />
        )
      }
    />
  );
}
